import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import { PrivacyProvider } from './components/utils_jsx/PrivacyContext'; // ajuste le chemin si besoin

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <PrivacyProvider>
        <App />
      </PrivacyProvider>
    </BrowserRouter>
  </StrictMode>,
);